import { render } from "./ControllerUserList.vue?vue&type=template&id=633a67fb&scoped=true"
import script from "./ControllerUserList.vue?vue&type=script&lang=js"
export * from "./ControllerUserList.vue?vue&type=script&lang=js"

import "./ControllerUserList.vue?vue&type=style&index=0&id=633a67fb&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633a67fb"]])

export default __exports__